import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import OrderSelectModal from "../common/OrderSelectModal";
import PartnerUserSelectModal from "../common/PartnerUserSelectModal";
import ItemSelectModal from "../common/ItemSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];

function OrderRegModal({ title, onClose, handleRegSuccessSave, userTypeModalOption, unitCurrencyModalOption, MenuUpdateYN, payload }) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    order_id: null,
    order_number: '',
    order_date: appStore.YYYY_MM_DD(),
    order_name: '',
    order_partner_id: 0,
    order_partner_name: '',
    order_partner_manager: '',
    order_partner_manager_phone: '',
    order_partner_manager_mail: '',
    order_partner_delivery_post: '',
    order_partner_delivery_address: '',
    order_partner_delivery_address_add: '',
    order_bigo: '',
    order_ref_order_id: null,
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectOrderModalOpen, setSelectOrderModalOpen] = useState(false);
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');
  const [upperPartnerId, setUpperPartnerId] = useState(0);

  const handleSetting = () => {
    setItemColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'order_item_id', headerName: 'order_item_id', headerAlign: 'center', align:'center' },
      { field: 'order_item_name', headerName: '품목', flex: 1, minWidth: 130, headerAlign: 'center', align:'left' },
      { field: 'order_package_count', headerName: '수량', type: 'number', width: 80, headerAlign: 'center', align:'right', editable: true },
      { field: 'order_pack_rate', headerName: '포장수량', type: 'number', width: 70, headerAlign: 'center', align:'right', editable: true },
      { field: 'order_item_count', headerName: '수주수량', type: 'number', width: 90, headerAlign: 'center', align:'right', editable: false },
      { field: 'order_item_price_currency', headerName: '통화단위', type: 'singleSelect', width: 80, 
        valueOptions: () => unitCurrencyModalOption ?? [], valueFormmatter: ({  value }) => 
          unitCurrencyModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'order_item_price', headerName: '단가', type: 'number',width: 90, headerAlign: 'center', editable: true},
      { field: 'order_item_sv_price', headerName: '공급가액', type: 'number', width: 100, headerAlign: 'center', align:'right', editable: true },
      { field: 'order_item_vat_price', headerName: '부가세액', type: 'number',width: 90, headerAlign: 'center', align:'right', editable: true },
      { field: 'order_item_total_price', headerName: '합계금액', type: 'number',width: 110, headerAlign: 'center', align:'right' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'order_user_id', headerName: 'order_user_id', width: 0, headerAlign: 'center' },
      { field: 'order_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'order_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'order_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'order_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'order_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setItemColumnVisibilityModel({
      id: false,
      actions: (MenuUpdateYN==='Y')?true:false,
      order_item_id: false,
      order_item_name: true,
      order_package_count: true,
      order_pack_rate: true,
      order_item_count: true,
      order_item_price_currency: false,
      order_item_price: true,
      order_item_sv_price: true,
      order_item_vat_price: true,
      order_item_total_price: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: (MenuUpdateYN==='Y')?true:false,
      order_user_id: false,
      order_user_name: true,
      order_user_dept_name: true,
      order_user_position_name: true,
      order_user_type: true,
      order_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: (MenuUpdateYN==='Y')?true:false,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: (MenuUpdateYN==='Y')?true:false,
    order_item_id: false,
    order_item_name: true,
    order_package_count: true,
    order_pack_rate: true,
    order_item_count: true,
    order_item_price_currency: false,
    order_item_price: true,
    order_item_sv_price: true,
    order_item_vat_price: true,
    order_item_total_price: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: (MenuUpdateYN==='Y')?true:false,
    order_user_id: false,
    order_user_name: true,
    order_user_dept_name: true,
    order_user_position_name: true,
    order_user_type: true,
    order_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: (MenuUpdateYN==='Y')?true:false,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    if (payload && (payload.from === 'excel_upload' || payload.from === 'excel_dragdrop') && payload.uploadResult) {
      const data = payload.uploadResult;

      setInputs(prev => ({
        ...prev,
        order_name: data.order_name || '',
        order_date: data.order_date || appStore.YYYY_MM_DD(),
        order_partner_id: Number(data.partner_id) || 0,
        order_partner_name: data.partner_name || '',
        order_partner_manager: data.partner_manager || '',
        order_partner_manager_mail: data.partner_manager_mail || '',
        order_partner_manager_phone: data.partner_manager_phone || '',
        order_partner_delivery_post: data.ship_zip || '',
        order_partner_delivery_address: data.ship_addr || '',
        order_partner_delivery_address_add: data.ship_addr_detail || '',
        order_bigo: data.remark || '',
      }));

      if (data.items && data.items.length > 0) {
        const validItems = data.items.filter(it => it.item_id || it.item_name);
        const parsedItems = validItems.map((it, idx) => {
          const qty = Number(it.qty) || 0; 
          const price = Number(it.price) || 0;
          const supplyPrice = Number(it.supply) || (qty * price);
          const vatPrice = Number(it.vat) || Math.floor(supplyPrice * 0.1);
          const totalPrice = supplyPrice + vatPrice;

          return {
            id: idx + 1,
            order_item_id: it.item_id || '',
            order_item_name: it.item_name || '',
            order_package_count: qty,
            order_pack_rate: 1,
            order_item_count: qty * 1,
            order_item_price_currency: 144, 
            order_item_price: price,
            order_item_sv_price: supplyPrice,
            order_item_vat_price: vatPrice,
            order_item_total_price: totalPrice,
            row_type: 'A',
            update_type: 'U'
          };
        });
        setItemRows(parsedItems);
        setUpdateItemRows(parsedItems);
      }

      if (data.users && data.users.length > 0) {
        const validUsers = data.users.filter(u => u.user_id || u.user_name);
        const parsedUsers = validUsers.map((u, idx) => ({
          id: idx + 1,
          order_user_id: u.user_id || '',
          order_user_name: u.user_name || '',
          order_user_type: Number(u.user_type_id) || 0,
          order_user_dept_name: u.user_dept_name || '',
          order_user_position_name: u.user_position_name || '',
          order_user_bigo: u.remark || '',
          row_type: 'A',
          update_type: 'U'
        }));
        setUserRows(parsedUsers);
        setUpdateUserRows(parsedUsers);
      }
    }
  }, [payload]);

  useEffect(() => {
      realFiles = [];
      tmpRealFiles = [];
      handleSetting();
      setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        order_item_id: '',
        order_item_name: '',
        order_package_count: '',
        order_pack_rate: '',
        order_item_count: '',
        order_item_price_currency: 144,
        order_item_price: 0,
        order_item_sv_price: 0,
        order_item_vat_price: 0,
        order_item_total_price: 0,
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [itemRows]);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; 
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        order_user_id: '',
        order_user_name: '',
        order_user_dept_name: '',
        order_user_position_name: '',
        order_user_type: 0,
        order_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);
  
  const onClick = (e)=>{ 
    setSelectModalTitle('수주처 목록')
    setSelectPartnerModalOpen(true);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'order_partner_manager_phone'){ 
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    if(newRow.order_package_count > 99999 || newRow.order_pack_rate > 99999){
      return;
    }

    if(oldRow.order_item_id !== newRow.order_item_id || oldRow.order_item_name !== newRow.order_item_name 
      || oldRow.order_package_count !== newRow.order_package_count || oldRow.order_pack_rate !== newRow.order_pack_rate
      || oldRow.order_item_price !== newRow.order_item_price || oldRow.order_item_sv_price !== newRow.order_item_sv_price || oldRow.order_item_vat_price !== newRow.order_item_vat_price){
      
      let newUpdateDataArray = {}
      const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; 
      
      if (newRow.order_package_count !== oldRow.order_package_count || newRow.order_pack_rate !== oldRow.order_pack_rate){
        const newCount = Number(newRow.order_package_count || 0) * Number(newRow.order_pack_rate || 1);
        newUpdateDataArray = { 
          ...newRow
          , ['order_item_count']: newCount
          , ['order_item_sv_price']: newCount * (newRow.order_item_price)
          , ['order_item_vat_price']: (newCount * (newRow.order_item_price))/10
          , ['order_item_total_price']: newCount * (newRow.order_item_price) + ((newCount * (newRow.order_item_price))/10)
          , update_type: 'U' }; 
      } else if (newRow.order_item_price !== oldRow.order_item_price) { 
        newUpdateDataArray = { 
          ...newRow
          , ['order_item_sv_price']: newRow.order_item_count * (newRow.order_item_price)
          , ['order_item_vat_price']: (newRow.order_item_count * (newRow.order_item_price))/10
          , ['order_item_total_price']: newRow.order_item_count * (newRow.order_item_price) + ((newRow.order_item_count * (newRow.order_item_price))/10)
          , update_type: 'U' }; 
      } else if (newRow.order_item_sv_price !== oldRow.order_item_sv_price) { 
        newUpdateDataArray = { 
          ...newRow
          , ['order_item_vat_price']: (newRow.order_item_sv_price/10)
          , ['order_item_total_price']: newRow.order_item_sv_price+(newRow.order_item_sv_price/10)
          , update_type: 'U' }; 
      } else if (newRow.order_item_vat_price !== oldRow.order_item_vat_price) { 
        newUpdateDataArray = { 
          ...newRow
          , ['order_item_total_price']: newRow.order_item_sv_price + newRow.order_item_vat_price
          , update_type: 'U' }; 
      } else { 
        newUpdateDataArray = { ...newRow, update_type: 'U' }; 
      }
      
      var row_order_item_id = '';
      var row_order_item_name = '';
      var row_order_package_count = '';
      var row_order_pack_rate = '';
      var row_order_item_count = '';
      var row_order_item_price_currency = 144;
      var row_order_item_price = 0;
      var row_order_item_sv_price = 0;
      var row_order_item_vat_price = 0;
      var row_order_item_total_price = 0;

      if(String(newRow.row_type) === "A"){
        if(newRow.order_item_id !== '' || newRow.order_item_name !== '' || newRow.order_package_count !== '' || newRow.order_pack_rate !== ''
          || newRow.order_item_price_currency !== 144 || newRow.order_item_price !== 0 || newRow.order_item_sv_price !== 0
          || newRow.order_item_vat_price !== 0 || newRow.order_item_total_price !== 0){
          row_order_item_id = newRow.order_item_id;
          row_order_item_name = newRow.order_item_name;
          row_order_package_count = newRow.order_package_count;
          row_order_pack_rate = newRow.order_pack_rate;
          row_order_item_count = newRow.order_item_count;
          row_order_item_price_currency = newRow.order_item_price_currency;
          row_order_item_price = newRow.order_item_price;
          row_order_item_sv_price = newRow.order_item_sv_price;
          row_order_item_vat_price = newRow.order_item_vat_price;
          row_order_item_total_price = newRow.order_item_total_price;
        }
      }else{
        itemRows.map((data) => data.id === newRow.id 
          && (data.order_item_id !== newRow.order_item_id || data.order_item_name !== newRow.order_item_name 
            || data.order_package_count !== newRow.order_package_count || data.order_pack_rate !== newRow.order_pack_rate
            || data.order_item_price_currency !== newRow.order_item_price_currency || data.order_item_price !== newRow.order_item_price
            || data.order_item_sv_price !== newRow.order_item_sv_price || data.order_item_vat_price !== newRow.order_item_vat_price
            || data.order_item_total_price !== newRow.order_item_total_price)?
          (
            row_order_item_id = data.order_item_id,
            row_order_item_name = data.order_item_name,
            row_order_package_count = data.order_package_count,
            row_order_pack_rate = data.order_pack_rate,
            row_order_item_count = data.order_item_count,
            row_order_item_price_currency = data.order_item_price_currency,
            row_order_item_price = data.order_item_price,
            row_order_item_sv_price = data.order_item_sv_price,
            row_order_item_vat_price = data.order_item_vat_price,
            row_order_item_total_price = data.order_item_total_price
          ):""
        )
      }
      
      if(row_order_item_id === '' && row_order_item_name === '' && row_order_package_count === '' && row_order_pack_rate === ''
        && row_order_item_price_currency === 144 && row_order_item_price === 0 && row_order_item_sv_price === 0 && row_order_item_vat_price === 0
        && row_order_item_total_price === 0){
        if(updateItemRows.length > 0){
          setUpdateItemRows(updateItemRows.filter((data) => data.id !== newRow.id));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateItemRows(updateItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }

        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; 
    const newNoDataArray = { ...newRow, update_type: 'N' }; 
    
    if(oldRow.order_user_id !== newRow.order_user_id || oldRow.order_user_type !== newRow.order_user_type || oldRow.order_user_bigo !== newRow.order_user_bigo){
    
      var row_order_user_id = '';
      var row_order_user_name = '';
      var row_order_user_type = 0;
      var row_order_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        if(newRow.order_user_id !== '' || newRow.order_user_name !== '' || (newRow.order_user_type !== 0 && newRow.order_user_type !== null) || newRow.order_user_bigo !== '' ){
          row_order_user_id = newRow.order_user_id;
          row_order_user_name = newRow.order_user_name;
          row_order_user_type = newRow.order_user_type;
          row_order_user_bigo = newRow.order_user_bigo;
        }
      }else{
        userRows.map((data) => data.id === newRow.id 
          && (data.order_user_id !== newRow.order_user_id || data.order_user_name !== newRow.order_user_name || data.order_user_type !== newRow.order_user_type || data.order_user_bigo !== newRow.order_user_bigo )?
          (
            row_order_user_id = data.order_user_id,
            row_order_user_name = data.order_user_name,
            row_order_user_type = data.order_user_type,
            row_order_user_bigo = data.order_user_bigo
          ):""
        )
      }
      
      if(row_order_user_id === '' && row_order_user_name === '' && row_order_user_bigo === '' && (row_order_user_type === 0 || row_order_user_type === null)){
        if(updateUserRows.length > 0){
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }

        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const itemAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        order_item_id: '',
        order_item_name: '',
        order_package_count: '',
        order_pack_rate: '',
        order_item_count: '',
        order_item_price_currency: 144,
        order_item_price: 0,
        order_item_sv_price: 0,
        order_item_vat_price: 0,
        order_item_total_price: 0,
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        order_item_id: object.row.order_item_id,
        order_item_name: object.row.order_item_name,
        order_package_count: object.row.order_package_count,
        order_pack_rate: object.row.order_pack_rate,
        order_item_count: object.row.order_item_count,
        order_item_price_currency: object.row.order_item_price_currency,
        order_item_price: object.row.order_item_price,
        order_item_sv_price: object.row.order_item_sv_price,
        order_item_vat_price: object.row.order_item_vat_price,
        order_item_total_price: object.row.order_item_total_price,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
  };

  const itemDeleteClick = (object) => {
    setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
  };

  const userAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        order_user_id: '',
        order_user_name: '',
        order_user_dept_name: '',
        order_user_position_name: '',
        order_user_type: 0,
        order_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        order_user_id: object.row.order_user_id,
        order_user_name: object.row.order_user_name,
        order_user_dept_name: object.row.order_user_dept_name,
        order_user_position_name: object.row.order_user_position_name,
        order_user_type: object.row.order_user_type,
        order_user_bigo: object.row.order_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {
      tmpRealFiles = []; 
      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
        tmpRealFiles.push(input.files[i]);
      }

      var array = [];
      for(var i=0; i<tmpRealFiles.length; i++){
        var tmp_sever_file_name = tmpRealFiles[i].name;
        var tmp_file_name = tmpRealFiles[i].name;
        var tmp_file_size = tmpRealFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(tmpRealFiles[i].size);
        var tmp_file_type = tmpRealFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(tmpRealFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows((fileRows) => [...fileRows.filter((r) => !(r.row_type === 'A' && r.update_type === 'N')), ...array]);
    };
  };

  const fileDeleteClick = (object) => {
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }
    setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
  };

  const handleOrderRef = (event) => {
    setSelectModalTitle('수주 목록')
    setSelectOrderModalOpen(true);
  }

  const handleOnCellClick = (params) => {
    if(params.field === 'order_item_name'){
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: params.row.id,
        order_item_id: params.row.order_item_id,
        order_item_name: params.row.order_item_name,
        order_package_count: params.row.order_package_count,
        order_pack_rate: params.row.order_pack_rate,
        order_item_count: params.row.order_item_count,
        order_item_price_currency: params.row.order_item_price_currency,
        order_item_price: params.row.order_item_price,
        order_item_sv_price: params.row.order_item_sv_price,
        order_item_vat_price: params.row.order_item_vat_price,
        order_item_total_price: params.row.order_item_total_price,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'order_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        order_user_id: params.row.order_user_id,
        order_user_name: params.row.order_user_name,
        order_user_dept_name: params.row.order_user_dept_name,
        order_user_position_name: params.row.order_user_position_name,
        order_user_type: params.row.order_user_type,
        order_user_bigo: params.row.order_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handleOrderClick = (object) => {
    if(object.length !== 0){
      Swal.fire({
        title: '수주번호 '+object[0].order_number+' 복사',
        text: '확인버튼을 클릭하면 수주정보가 복사됩니다',
        showCancelButton: true,
        confirmButtonText: '확인', 
        cancelButtonText: '취소',
        confirmButtonColor: '#0067a3',
        cancelButtonColor: '#d33',
      }).then(result => {
          if (result.isConfirmed) {
            setInputs({
              order_id: null,
              order_number: '',
              order_date: appStore.YYYY_MM_DD(),
              order_name: object[0].order_name,
              order_partner_id: Number(object[0].order_partner_id),
              order_partner_name: object[0].order_partner_name,
              order_partner_manager: object[0].order_partner_manager,
              order_partner_manager_phone: object[0].order_partner_manager_phone,
              order_partner_manager_mail: object[0].order_partner_manager_mail,
              order_partner_delivery_post: object[0].order_partner_delivery_post,
              order_partner_delivery_address: object[0].order_partner_delivery_address,
              order_partner_delivery_address_add: object[0].order_partner_delivery_address_add,
              order_bigo: object[0].order_bigo,
              order_ref_order_id: Number(object[0].order_id),
            });
        
            var itemData = object.filter((item, index) => {
              return (
                object.findIndex((item2, index2) => {
                  return typeof item.order_item_seq !== 'undefined' && item.order_item_seq === item2.order_item_seq;
                }) === index
              );
            });
        
            setItemRows(itemData.map((item, index) => ({
              id: item.order_item_seq,
              order_item_id: item.order_item_id,
              order_item_name: item.order_item_name,
              order_package_count: item.order_package_count,
              order_pack_rate: item.order_pack_rate,
              order_item_count: item.order_item_count,
              order_item_price_currency: item.order_item_price_currency,
              order_item_price: item.order_item_price,
              order_item_sv_price: item.order_item_sv_price,
              order_item_vat_price: item.order_item_vat_price,
              order_item_total_price: item.order_item_total_price,
              row_type: 'A',
              update_type: 'U'
            })));

            setUpdateItemRows(itemData.map((item, index) => ({
              id: item.order_item_seq,
              order_item_id: item.order_item_id,
              order_item_name: item.order_item_name,
              order_package_count: item.order_package_count,
              order_pack_rate: item.order_pack_rate,
              order_item_count: item.order_item_count,
              order_item_price_currency: item.order_item_price_currency,
              order_item_price: item.order_item_price,
              order_item_sv_price: item.order_item_sv_price,
              order_item_vat_price: item.order_item_vat_price,
              order_item_total_price: item.order_item_total_price,
              row_type: 'A',
              update_type: 'U'
            })));

            var userData = object.filter((item, index) => {
              return (
                object.findIndex((item2, index2) => {
                  return typeof item.order_user_seq !== 'undefined' && item.order_user_seq === item2.order_user_seq;
                }) === index
              );
            });
        
            setUserRows(userData.map((item, index) => ({
              id: item.order_user_seq,
              order_user_id: item.order_user_id,
              order_user_name: item.order_user_name,
              order_user_dept_name: item.order_user_dept_name,
              order_user_position_name: item.order_user_position_name,
              order_user_type: item.order_user_type,
              order_user_bigo: item.order_user_bigo,
              row_type: 'A',
              update_type: 'U'
            })));

            setUpdateUserRows(userData.map((item, index) => ({
              id: item.order_user_seq,
              order_user_id: item.order_user_id,
              order_user_name: item.order_user_name,
              order_user_dept_name: item.order_user_dept_name,
              order_user_position_name: item.order_user_position_name,
              order_user_type: item.order_user_type,
              order_user_bigo: item.order_user_bigo,
              row_type: 'A',
              update_type: 'U'
            })));

          } else if (result.isDismissed) {
            const nextInputs = {
                ...inputs,
                ["order_ref_order_id"]: null,
            };
            setInputs(nextInputs);
          }
      })
    }else{
      setInputs({
        order_id: null,
        order_number: '',
        order_date: appStore.YYYY_MM_DD(),
        order_name: '',
        order_partner_id: 0,
        order_partner_name: '',
        order_partner_manager: '',
        order_partner_manager_phone: '',
        order_partner_manager_mail: '',
        order_partner_delivery_address: '',
        order_partner_delivery_address_add: '',
        order_bigo: '',
        order_ref_order_id: 0,
      });
      setItemRows([]);
      setUpdateItemRows([]);
      setUserRows([]);
      setUpdateUserRows([]);
    }
  };

  const handlePartnerUserClick = (object) => {
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email
    var partner_delivery_post = object.partner_head_address_post === undefined?'':object.partner_head_address_post
    var partner_delivery_address = object.partner_head_address === undefined?'':object.partner_head_address
    var partner_delivery_address_add = object.partner_head_address_addition === undefined?'':object.partner_head_address_addition

    const nextInputs = {
        ...inputs,
        ["order_partner_id"]: object.id,
        ["order_partner_name"]: object.partner_name,
        ["order_partner_manager"]: partner_user_name,
        ["order_partner_manager_phone"]: partner_user_phone,
        ["order_partner_manager_mail"]: partner_user_email,
        ["order_partner_delivery_post"]: partner_delivery_post,
        ["order_partner_delivery_address"]: partner_delivery_address,
        ["order_partner_delivery_address_add"]: partner_delivery_address_add,
        ["order_ref_order_id"]: null
    };
    setInputs(nextInputs);
    setUpperPartnerId(object.id);
  };
  
  const handleInputItemClick = (object) => {
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(itemRows[i].order_item_id === object.id && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.order_item_id){
        if (object.id === '') {
          processItemRowUpdate({
            id: selectItemData.id, order_item_id: '', order_item_name: '', order_package_count: '', order_pack_rate: '', order_item_count: '',
            order_item_price_currency: 144, order_item_price: 0, order_item_sv_price: 0, order_item_vat_price: 0, order_item_total_price: 0,
            row_type: selectItemData.row_type, update_type: selectItemData.update_type,
          }, { ...selectItemData });
        } else {
          var item_real_price = 0; 
          if(object.partner_id === inputs.order_partner_id && object.item_in_out_type === 'I' && object.item_partner_price !== undefined){
            item_real_price = object.item_partner_price; 
          } else {
            item_real_price = object.item_stock_price; 
          }
          
          // ▼ 품목 선택 시 Default(포장비율) 바인딩
          processItemRowUpdate(
            {
              id: selectItemData.id,
              order_item_id: object.id,
              order_item_name: object.item_name + ' ' +appStore.ITEM_FULL_SPEC_MAKE( object.item_spec, object.item_width, object.item_depth, object.item_height),
              order_package_count: selectItemData.order_package_count,
              order_pack_rate: object.item_order_package_count || 1, // 품목 마스터의 수주포장비율 맵핑
              order_item_count: Number(selectItemData.order_package_count || 0) * Number(object.item_order_package_count || 1),
              order_item_price_currency: object.item_stock_price_currency,
              order_item_price: item_real_price,
              order_item_sv_price: item_real_price,
              order_item_vat_price: selectItemData.order_item_vat_price,
              order_item_total_price: selectItemData.order_item_total_price,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            },
            {
              id: selectItemData.id,
              order_item_id: selectItemData.order_item_id,
              order_item_name: selectItemData.order_item_name,
              order_package_count: selectItemData.order_package_count,
              order_pack_rate: selectItemData.order_pack_rate,
              order_item_count: selectItemData.order_item_count,
              order_item_price_currency: selectItemData.order_item_price_currency,
              order_item_price: selectItemData.order_item_price,
              order_item_sv_price: selectItemData.order_item_sv_price,
              order_item_vat_price: selectItemData.order_item_vat_price,
              order_item_total_price: selectItemData.order_item_total_price,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            }
          )
        }
      }
    }
  };

  const handleUserClick = (object) => {
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].order_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.user_id){

        processUserRowUpdate(
          {
            id : selectUserData.id,
            order_user_id: object.id,
            order_user_name: object.user_name,
            order_user_dept_name: object.dept_name,
            order_user_position_name: object.position_name,
            order_user_type: (selectUserData.order_user_type === 0 || selectUserData.order_user_type === '') ? 178 : selectUserData.order_user_type,
            order_user_bigo: selectUserData.order_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            order_user_id: selectUserData.order_user_id,
            order_user_name: selectUserData.order_user_name,
            order_user_type: (selectUserData.order_user_type === 0 || selectUserData.order_user_type === '') ? 178 : selectUserData.order_user_type,
            order_user_dept_name: selectUserData.order_user_dept_name,
            order_user_position_name: selectUserData.order_user_position_name,
            order_user_bigo: selectUserData.order_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';
    if(inputs.order_name.trim() === '' || inputs.order_name.trim() === 0){
      msg = '수주명은 필수 선택 입니다.'
    }else if((inputs.order_date) === '' || (inputs.order_date) < '2025-01-01' || (inputs.order_date).length != 10){
      msg = '수주일자는 필수 입력 입니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    }else if(inputs.order_partner_id === '' || inputs.order_partner_id === 0){
      msg = '수주처는 필수 입력 입니다.'
    }else if(inputs.order_partner_manager_phone.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.order_partner_manager_phone.trim())){
      msg = '담당자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자3,4자리-숫자4자리)';
    }else if(inputs.order_partner_manager_mail.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.order_partner_manager_mail.trim())){
      msg = '담당자 E-Mail 입력이 올바르지 않습니다.';
    }
    
    if(msg === '' && (itemRows.filter((data) => (data.update_type !== 'D' && (data.row_type !== 'A' || data.update_type !== 'N')))).length === 0){ 
      msg = '수주 품목이 존재하지 않습니다.';
    }else if(updateItemRows.length > 0 && msg === ''){ 
      for(let i = 0; i < updateItemRows.length; i++) {
        const order_item_id = updateItemRows[i].order_item_id;
        const order_package_count = updateItemRows[i].order_package_count;
        const order_item_count = updateItemRows[i].order_item_count;
        const order_item_price_currency = updateItemRows[i].order_item_price_currency;
        const order_item_sv_price = updateItemRows[i].order_item_sv_price;
        const order_item_vat_price = updateItemRows[i].order_item_vat_price;
        
        if(order_item_id === 0 || order_item_id === '') {
          msg = '선택되지 않는 수주 품목이 존재합니다.';
          break;
        }
        if(order_package_count === 0 || order_package_count === '' || order_package_count === null) {
          msg = '입력되지 않는 수량이 존재합니다.';
          break;
        }
        if(order_package_count < 0) {
          msg = '수량은 음수가 될 수 없습니다.';
          break;
        }
        if(order_item_price_currency === 0 || order_item_price_currency === '') {
          msg = '선택되지 않는 통화단위가 존재합니다.';
          break;
        }
        if(order_item_sv_price !== "" && order_item_sv_price < 0) {
          msg = '공급가액은 음수가 될 수 없습니다.';
          break;
        }
        if(order_item_vat_price !== "" && order_item_vat_price < 0) {
          msg = '부가세액은 음수가 될 수 없습니다.';
          break;
        }
      }
    }

    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < updateUserRows.length; i++) {
        const order_user_id = updateUserRows[i].order_user_id;
        const order_user_type = updateUserRows[i].order_user_type;
        
        if(order_user_id === 0 || order_user_id === '') {
          msg = '선택되지 않는 담당자명이 존재합니다.';
          break;
        }
        if(order_user_type === 0 || order_user_type === '') {
          msg = '선택되지 않는 담당자유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">수주 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
            
      axios.post("/api/p/Order/Reg", {inputs, updateItemRows, updateUserRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          var selectID = response.data;
          if(updateFileRows.length > 0) {

            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Order');
            formData.append('type', 'Reg');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));
            
            for(var i=0; i<realFiles.length; i++){            
              formData.append('files', realFiles[i]);
            }
            
            axios.post('/api/SaveCommon/GridFileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            }).then(response => {
              realFiles = []; tmpRealFiles = [];
              handleRegSuccessSave(selectID);
            }).catch(error => {
              appStore.capture();
            });
          }else{
            handleRegSuccessSave(selectID);
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });
    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="수주 정보" value="1" />
                <Tab label="수주 품목" value="2" />
                <Tab label="수주 담당자" value="3" />
                <Tab label="수주 파일" value="4" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">수주명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="수주명" value={inputs.order_name} name="order_name" onChange={(e) => onChange(e) } autoComplete="off"/>
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">수주번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="수주번호" value={inputs.order_number} name="order_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">수주일자<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="date" placeholder="수주일자" value={inputs.order_date} name="order_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">수주처<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="수주처" value={inputs.order_partner_name} name="order_partner_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', cursor: 'pointer'}} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">수주처 담당자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="이름" value={inputs.order_partner_manager} name="order_partner_manager" onChange={(e) => onChange(e) } style={{ float: 'left', width: '112px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="휴대폰번호" value={inputs.order_partner_manager_phone} name="order_partner_manager_phone" onChange={(e) => onHypenChange(e) } style={{ float: 'left', width: '300px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="메일주소" value={inputs.order_partner_manager_mail} name="order_partner_manager_mail" onChange={(e) => onChange(e) } style={{width: '360px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">수주처 배송지</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="우편번호" value={inputs.order_partner_delivery_post} name="order_partner_delivery_post" onChange={(e) => onChange(e) } style={{ float: 'left', width: '150px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="주소" value={inputs.order_partner_delivery_address} name="order_partner_delivery_address" onChange={(e) => onChange(e) } style={{width: '620px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title"></div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="상세주소" value={inputs.order_partner_delivery_address_add} name="order_partner_delivery_address_add" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="비고" name="order_bigo" value={inputs.order_bigo} onChange={(e) => onChange(e) } style={{width: '768px', height: '110px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
                <div className="modal_grid">
                  <DataGrid
                    apiRef={apiRef}
                    rows={itemRows}
                    columns={itemColumns}
                    columnVisibilityModel={itemColumnVisibilityModel}
                    editMode='cell'  
                    processRowUpdate={processItemRowUpdate}        
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    onCellClick={handleOnCellClick}
                    disableColumnSorting
                  />
                </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button" style={{float: 'left'}}>
                      <Button 
                        onClick={ handleOrderRef }
                        className="btn-p btn-u"
                        style={{width: '130px'}}
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#0067a3", 
                            backgroundColor: "#0067a3",
                            ":hover": { boxShadow: "2px 2px 2px #0067a3" , backgroundColor: "#0067a3", borderColor: "#0067a3"}
                        }} 
                        variant="outlined">
                        수주조회
                      </Button>
                    </div>
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {MenuUpdateYN === 'Y' &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                      </Button> }
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectOrderModalOpen && (<OrderSelectModal
          onClose={() => {
              setSelectOrderModalOpen(false);
          }}
          title={selectmodalTitle}
          openType={'Outgoing'}
          handleOrderClick={handleOrderClick}
          />)}
        {isSelectPartnerModalOpen && (<PartnerUserSelectModal
          onClose={() => {
              setSelectPartnerModalOpen(false);
          }}
          title={selectmodalTitle}
          handlePartnerUserClick={handlePartnerUserClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          upperPartnerId={upperPartnerId}
          nowIOType={'O'}
          handleInputItemClick={handleInputItemClick}
          />)}

        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </PCModal>
  );
}

export default OrderRegModal;